import { configureStore } from '@reduxjs/toolkit';
import heroReducer from './heroSlice';
import familyReducer from './familySlice'
import blogReducer from './blogSlice'
import footerReducer from './footerSlice'
import teamReducer from './teamSlice'
import testimonialReducer from './testimonialSlice'
import contactReducer from './contactSlice'
import translationReducer from './translationSlice'
import generalReducer from './generalSlice'
import localProductsReducer from './localProductSlice'
import productFiltersReducer from './localProductFiltersSlice'
import countryReducer from './countrySlice'
import productB2Breducer from './productB2BSlice'
import productGlobalReducer from './productGlobalSlice'
import plantReducer from './plantSlice'
import portfolioReducer from './portfolioSlice'
import infoDisclosureReducer from './infoDisclosureSlice'
import reportSlice from './reportSlice'
import timelineSlice from './timelineSlice'
import companyPlatformReducer from './companyPlatformSlice'
import localReportSlice from './localReportSlice';
import enviroReducer from './enviroSlice';

const store = configureStore({
    reducer: {
        hero: heroReducer,
        family: familyReducer,
        blog: blogReducer,
        footer: footerReducer,
        team: teamReducer,
        testimonial: testimonialReducer,
        contact: contactReducer,
        translation: translationReducer,
        general: generalReducer,
        localProducts: localProductsReducer,
        productFilters: productFiltersReducer,
        country: countryReducer,
        productB2B: productB2Breducer,
        productGlobal: productGlobalReducer,
        plant: plantReducer,
        portfolio: portfolioReducer,
        infoDisclosure: infoDisclosureReducer,
        report: reportSlice,
        timeline: timelineSlice,
        companyPlatform: companyPlatformReducer,
        localReport: localReportSlice,
        enviro: enviroReducer,
    },
});

export default store;
